export default __webpack_public_path__ + "static/media/ni.d6158b8e.svg";